import { render, staticRenderFns } from "./ValidatableCheckbox.vue?vue&type=template&id=2ab48f6f&"
import script from "./ValidatableCheckbox.vue?vue&type=script&lang=js&"
export * from "./ValidatableCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports